(function() {
  'use strict';

  function OrganisationController(
    RouterHelper,
    Organisations,
    Utils
  ) { // Replaced Router with RouterHelper
    var ctrl = this;

    ctrl.organisation = {};
    ctrl.user = {};
    ctrl.loaded = true;

    Utils.setPageTitle('New organisation');

    ctrl.request = function(isValid) {
      ctrl.formIsSubmitted = true;

      if (isValid) {
        var rqOrg = angular.copy(ctrl.organisation);

        ctrl.user.state = 'active';
        Organisations.create(rqOrg)
          .then(function() {
            RouterHelper.navigate(['/organisations']);
          })
          .catch(Utils.showError);
      }
    };

    ctrl.remove = function() {
      Utils.swal({
        title: 'Are you sure you want to remove this organisation?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK'
      });
    };
  }

  OrganisationController.$inject = [
    'RouterHelperService',
    'OrganisationsService',
    'UtilsService'
  ];

  angular.module('component.organisations')
    .component('organisationForm', {
      templateUrl: 'app/components/organisations/addform.html',
      controller: OrganisationController,
      controllerAs: 'orgCtrl'
    });
})();
